import http from "@/http/aisea/axios";

export default {
  // 燃料消費月次レポートAPI
  report(payload) {
    return http.get(`secure_dataflow/enterprise/engine/monthly/fuel/report/${payload.vessel_id}/${payload.yyyyMM}`, { responseType : 'blob' });
  },
};
